import { render, staticRenderFns } from "./PricelistsPage.vue?vue&type=template&id=509a05b6"
import script from "./PricelistsPage.vue?vue&type=script&lang=js"
export * from "./PricelistsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports